import {
  OrderItem,
  OrderStateEvent,
  OrderWithItems,
  Payment,
  PaymentStateEvent,
  PhotoEvent,
  PhotoProduct,
  Pricelist,
  QuantityPrice,
  ShoppingCartItem,
  ShoppingCartStateEvent,
  ShoppingCartWithItems,
} from 'common-models';

export class Model {
  public static deepCopyShoppingCartWithItems(input: ShoppingCartWithItems): ShoppingCartWithItems {
    return {
      id: input.id,
      isOpen: input.isOpen,
      createdTime: new Date(input.createdTime),
      items: input.items.map(Model.deepCopyShoppingCartItem),
      latestUpdatedTime: new Date(input.latestUpdatedTime),
      stateEvents: input.stateEvents.map(Model.deepCopyShoppingCartStateEvent),
      totalSum: input.totalSum,
      userIdentifier: input.userIdentifier,
    };
  }

  public static deepCopyShoppingCartItem(input: ShoppingCartItem): ShoppingCartItem {
    return {
      appliedPriceId: input.appliedPriceId,
      createdTime: new Date(input.createdTime),
      eventId: input.eventId,
      id: input.id,
      imageId: input.imageId,
      latestUpdatedTime: new Date(input.latestUpdatedTime),
      priceInSekExclVat: input.priceInSekExclVat,
      product: Model.deepCopyPhotoProduct(input.product),
      quantity: input.quantity,
      shoppingCartId: input.shoppingCartId,
    };
  }

  public static deepCopyOrderWithItems(input: OrderWithItems): OrderWithItems {
    return {
      id: input.id,
      isOpen: input.isOpen,
      createdTime: new Date(input.createdTime),
      items: input.items.map(Model.deepCopyOrderItem),
      latestUpdatedTime: new Date(input.latestUpdatedTime),
      orderStateEvents: input.orderStateEvents.map(Model.deepCopyOrderStateEvent),
      cartId: input.cartId,
      currentState: input.currentState,
      payment: Model.deepCopyPayment(input.payment),
      // stateEvents: input.stateEvents.map(Model.deepCopyShoppingCartStateEvent),
      totalSum: input.totalSum,
      userIdentifier: input.userIdentifier,
    };
  }
  static deepCopyPayment(input: Payment | undefined): Payment | undefined {
    return input === undefined
      ? undefined
      : {
          method: input.method,
          stateEvents: input.stateEvents.map(Model.deepCopyPaymentStateEvent),
          data: input.data,
        };
  }
  static deepCopyPaymentStateEvent(input: PaymentStateEvent): PaymentStateEvent {
    return {
      state: input.state,
      time: new Date(input.time),
      note: input.note,
    };
  }
  static deepCopyOrderStateEvent(input: OrderStateEvent): OrderStateEvent {
    return {
      state: input.state,
      time: new Date(input.time),
      note: input.note,
    };
  }

  public static deepCopyOrderItem(input: OrderItem): OrderItem {
    return {
      appliedPriceId: input.appliedPriceId,
      createdTime: new Date(input.createdTime),
      eventId: input.eventId,
      id: input.id,
      imageId: input.imageId,
      latestUpdatedTime: new Date(input.latestUpdatedTime),
      priceInSekExclVat: input.priceInSekExclVat,
      product: Model.deepCopyPhotoProduct(input.product),
      quantity: input.quantity,
      orderId: input.orderId,
    };
  }

  public static deepCopyPricelist(input: Pricelist): Pricelist {
    return {
      id: input.id,
      name: input.name,
      products: input.products.map(Model.deepCopyPhotoProduct),
    };
  }

  public static deepCopyPhotoProduct(input: PhotoProduct): PhotoProduct {
    return {
      priceListId: input.priceListId,
      names: {
        sv: input?.names?.sv,
        en: input?.names?.en,
      },
      prices: input.prices.map(Model.deepCopyQuantityPrice),
      productId: input.productId,
    };
  }

  public static deepCopyQuantityPrice(input: QuantityPrice): QuantityPrice {
    return {
      id: input.id,
      priceInSekExclVat: input.priceInSekExclVat,
      quantity: input.quantity,
    };
  }

  public static deepCopyShoppingCartStateEvent(input: ShoppingCartStateEvent): ShoppingCartStateEvent {
    return {
      state: input.state,
      time: new Date(input.time),
    };
  }

  public static deepCopyEvent(element: PhotoEvent): PhotoEvent {
    return {
      eventEndTime: new Date(element.eventEndTime),
      eventStartTime: new Date(element.eventStartTime),
      id: element.id,
      isFreeOfCharge: element.isFreeOfCharge,
      displayFreeOfChargeText: element.displayFreeOfChargeText,
      isExternalCopyright: element.isExternalCopyright,
      isPublic: element.isPublic,
      title: element.title,
      parentEventId: element.parentEventId,
      priceListId: element.priceListId,
      frontImage: element.frontImage,
    };
  }
  // private static getDate(input: any): Date { return new Date(input) };
}
